import { Pipe, PipeTransform } from '@angular/core';
import { Sort, SortOption } from './table-sort-options.component';

@Pipe({
  name: 'tableSortIcon',
  standalone: true,
})
export class TableSortIconPipe implements PipeTransform {
  transform(value: Sort | SortOption): string {
    let icon = `fa-sort-${value.type}-down`;
    const direction = 'direction' in value ? value.direction : value.defaultSort;

    if ((direction === 'desc' && value.type !== 'size') || (direction === 'asc' && value.type === 'size')) {
      icon += '-alt';
    }

    return `fas ${icon}`;
  }
}
